import { createTheme } from '@mui/material/styles'

interface Theme {
    bodyBackGroundColor: string
    textColor: string
}

interface MuiThemeColors {
    FIRST_COL_TRIAGE: string
    SECOND_COL_TRIAGE: string
    BLACK: string
    WHITE: string
}

export const DarkTheme: Theme = {
    bodyBackGroundColor: '#222222',
    textColor: '#ffffff',
}

export const LightTheme: Theme = {
    bodyBackGroundColor: '#ffffff',
    textColor: '#222222',
}

export const MUI_THEME_COLOR: MuiThemeColors = {
    FIRST_COL_TRIAGE: '#6895ff',
    SECOND_COL_TRIAGE: '#5f6fed',
    BLACK: '#000000',
    WHITE: '#ffffff',
}

export const themeMui = createTheme({
    palette: {
        primary: {
            light: '#ff00c8',
            main: MUI_THEME_COLOR.FIRST_COL_TRIAGE,
            dark: MUI_THEME_COLOR.SECOND_COL_TRIAGE,
            contrastText: MUI_THEME_COLOR.WHITE,
        },
        secondary: {
            light: '#ff00c8',
            main: MUI_THEME_COLOR.FIRST_COL_TRIAGE,
            dark: MUI_THEME_COLOR.SECOND_COL_TRIAGE,
            contrastText: MUI_THEME_COLOR.WHITE,
        },
    },
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    lineHeight: 1.1,
                },
            },
        },
    },
}) 